module.exports = __webpack_public_path__ + "img/class-banner.75f030c.jpg";